<wl-hero [hero]="hero()" [hasWidget]="hasWidget()" />
